import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const STUDENT_GAPS_ROUTE = {
  name: 'studentgaps',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  }
}
